import { css } from '@adornis/chemistry/directives/css.js';
import { stateful, useObservable } from '@adornis/functional-lit/stateful.js';
import { ServerTime } from '@legacy-db/time.js';
import { html, nothing } from 'lit';
import { DateTime } from 'luxon';

export const ILSServerTime = stateful(() => {
  const serverTime = useObservable(() => ServerTime.subscribeServerTime()(), []);
  if (!serverTime) return nothing;
  return html`
    <x-text ${css({ whiteSpace: 'nowrap', paddingBottom: '6px' })}>
      Serverzeit: ${DateTime.fromJSDate(serverTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS)}
    </x-text>
  `;
});
